import { useEffect, useState } from "react";
import CallAPI, { CallAPIform } from "../api";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
export default function useVerifyUser(token){
   const [account,setaccount]=useState();
   const [data,setdata]=useState({});
   const [file,setfile]=useState();
   const [loading,setloading]=useState(false);
   const [url,seturl]=useState();
   const navigate=useNavigate();
   useEffect(()=>{
    if(token){
        localStorage.setItem("access_token",token);
        CallAPI("user/selfdetails")
        .then(res=>{
            setaccount(res.data);
            setdata(res.data);
        })
        .catch(err=>console.log(err))
    }
   },[token])

   const handleChange=(field,value)=>{
    setdata(prev=>{
        let obj={...prev};
        obj[field]=value;
        return obj;
    })
   }

   const changeDp=(e)=>{
    if(e.target.files[0])
       { setfile(e.target.files[0]);
      const lnk=  URL.createObjectURL(e.target.files[0]);
      seturl(lnk);
    }
   }
   const submit=async ()=>{
    setloading(true);
    try {
        const form=new FormData();
        for(let el in data)
        if(data[el]!=account[el])
        form.append(el,data[el]);
        if(file)
        form.append('photo',file);
       await CallAPIform("user/lockuser","post",form);   
       Swal.fire("Success","profile submitted successfully","success");
     navigate("/");
    } catch (error) {
        console.log(error);
    }
    setloading(false);
   }

   return {account,loading,data,url,handleChange,changeDp,submit};
}